import { formatDate } from "@angular/common";

let appLocale = "en";

export function setAppLocale(lang: string): void {
  appLocale = lang || "en";
}

export function getAppLocale(): string {
  return appLocale;
}

// Keeps the existing English output; other languages use the browser Intl APIs.
export function formatLocalizedDateTime(
  date: Date,
  relative: "today" | "yesterday" | null,
): string {
  if (appLocale === "en") {
    if (!relative) {
      return formatDate(date, "MMM d, y, h:mm a", "en-US");
    }
    const label = relative === "today" ? "Today" : "Yesterday";
    return `${label}, ${formatDate(date, "h:mm a", "en-US")}`;
  }

  const time = new Intl.DateTimeFormat(appLocale, {
    hour: "numeric",
    minute: "2-digit",
  }).format(date);

  if (!relative) {
    const day = new Intl.DateTimeFormat(appLocale, {
      month: "short",
      day: "numeric",
      year: "numeric",
    }).format(date);
    return `${day}, ${time}`;
  }

  const word = new Intl.RelativeTimeFormat(appLocale, {
    numeric: "auto",
  }).format(relative === "today" ? 0 : -1, "day");
  const label = word.charAt(0).toLocaleUpperCase(appLocale) + word.slice(1);
  return `${label}, ${time}`;
}
